/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useConfig } from "../lib/react-query/useConfig";
import {
  formatDateTime as formatDateTimeUtil,
  formatTime as formatTimeUtil,
  formatDatePeriod as formatDatePeriodUtil,
  formatPrice as formatPriceUtil,
  formatDuration as formatDurationUtil,
} from "../utils/helpers/formatters";
import { useTranslate } from "./useTranslate";

export const useFormatters = () => {
  const { data: config } = useConfig();
  const { _t, translations } = useTranslate();

  const FormatDateTime = (props) => {
    return formatDateTimeUtil({ ...props, config, translations, translator: _t });
  };

  const FormatTime = (props) => {
    return formatTimeUtil({ ...props, config });
  };

  const FormatDatePeriod = (props) => {
    return formatDatePeriodUtil({ ...props, config, translator: _t });
  };

  const FormatPrice = (props) => {
    return formatPriceUtil({ ...props, translations });
  };

  const FormatDuration = (props) => {
    return formatDurationUtil({ ...props, translations });
  };

  return {
    FormatDateTime,
    FormatTime,
    FormatDatePeriod,
    FormatPrice,
    FormatDuration,
  };
};
